// JsFromRoutes CacheKey 20eae8286ec5744103b862b4693a8b98
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  archive: /* #__PURE__ */ definePathHelper('post', '/consumer/contacts/:id/archive'),
  unarchive: /* #__PURE__ */ definePathHelper('post', '/consumer/contacts/:id/unarchive'),
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/contacts'),
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/contacts'),
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/contacts/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/consumer/contacts/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/consumer/contacts/:id'),
}
